import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { onClick, isSelected } from './nav-fn';

import Home from '../../pages/home/home';
import Events from '../../pages/events/events';
import Music from '../../pages/music/music';
import Photos from '../../pages/photos/photos';
import Contact from '../../pages/contact/contact';

// import NeilPeartTribute from '../../../pages/features/neil-peart-tribute/neil-peart-tribute';

// Draft Pages
// import Epk from '../../pages/epk/epk';
// import Videos from '../../../pages/videos/videos/videos ';

import Footer from '../footer/footer';
import SocialBar from '../social-bar/social-bar';

import './nav.scss';

function Nav() {
  return (
    <div className='primary-layout'>
      <div className='nav noselect gutter'>
        <Link to='/' onClick={onClick}>
          <div className='nav-logo' />
        </Link>
        <div className='nav-choices'>
          <Link to='/' onClick={onClick} id='home' className={isSelected('home')}>Home</Link>
          <Link to='/events' onClick={onClick} id='events' className={isSelected('events')}>Events</Link>
          <Link to='/photos' onClick={onClick} id='photos' className={isSelected('photos')}>Photos</Link>
          <Link to='/music' onClick={onClick} id='music' className={isSelected('music')}>Music</Link>
          {/* <Link to='/videos' onClick={onClick} id='music' className={isSelected('videos')}>Videos</Link> */}
          <Link to='/contact' onClick={onClick} id='contact' className={isSelected('contact')}>Contact</Link>
        </div>
        <SocialBar />
      </div>
      <div className='main'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/events' element={<Events />} />
          <Route path='/photos' element={<Photos />} />
          <Route path='/music' element={<Music />} />
          <Route path='/contact' element={<Contact />} />

          {/* <Route path='/videos' component={Videos} /> */}

          {/* draft routes */}
          {/* <Route path='/epk' component={Epk} /> */}

          {/* dynamic rendering of routes / content */}
          {/* <Route path='/blog/neil-peart-tribute' component={NeilPeartTribute} /> */}
          
          {/* Default unmatched route goes to home page */ }
          <Route path='*' element={<Home/>} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default Nav;